import React from "react";
import "./HeaderStyle.css";

const HeaderTur1 = () => {
    return (<>
        <div className="row">
            <div className="col-2 headerPos1">
                <img className="imgHeader1" src="./escudo-setia-a.png"/>
            </div>
            <div className="col-7 headerPos2" >
<div className="row textTitle1">
    <div className="col">
        SINDICATO DE EMPLEADOS TEXTILES
    </div>
    </div><div className="row textTitle1">
    <div className="col">
        DE LA INDUSTRIA Y AFINES
    </div>
</div>
<div className="row textTitle2">
    <div className="col">
       de la República Argentina
    </div>
</div>
<div className="row textTitle3">
    <div className="col">
       www.setia.org.ar
    </div>
</div>
<div className="row textTitle3">
    <div className="col">
E-mail: Mar del Plata- San Clemente del Tuyú turismo@setia.org.ar
</div></div>
<div className="row textTitle3">
    <div className="col">
 Cordoba-Bariloche turismo@osetya.com.ar</div></div>
 <div className="row textTitle3">
    <div className="col">
 Ezeiza setiahotelezeiza@gmail.com</div></div>

            </div>
            
            <div className="col-2 headerPos3">
            <img className="imgHeader2" src="./icono-turismo-setia-a.png"/>
            </div>
        </div>


<hr style={{height:"1px",border:"none",color:"#333",backgroundColor:"#333"}}></hr>
        </>
    );

}

export default HeaderTur1;